module.exports = __webpack_public_path__ + "img/Banner-Quanta-Bank-01.4c6b3467.jpg";